import React, { memo, useCallback, useRef, useState } from 'react';

import { classer } from 'utils';

import FullScreenOverlay from './shared/FullScreenOverlay';

import classes from './Dropdown.module.scss';

const Dropdown = ({ options, selectedName, onClickFactory }) => {
  const [showDropdownOptions, setShowDropdownOptions] = useState(false);
  const optionsWrapperRef = useRef(null);

  const toggleDropdownOptions = useCallback(() => {
    setShowDropdownOptions(!showDropdownOptions);
  }, [showDropdownOptions]);

  const dynamicStyles = useCallback(
    () => ({
      height: showDropdownOptions ? `${24 * options.length}px` : '1.5rem',
      top: showDropdownOptions ? 0 : -5,
      opacity: showDropdownOptions ? 1 : 0
    }),
    [options.length, showDropdownOptions]
  );

  return options ? (
    <div className={classes.DropdownWrapper}>
      <FullScreenOverlay
        show={showDropdownOptions}
        onClick={toggleDropdownOptions}
      />
      <div className={classes.Dropdown}>
        <button
          className={classer([
            classes.DropdownHeader,
            showDropdownOptions && classes.Open,
            !showDropdownOptions && classes.Close
          ])}
          onClick={toggleDropdownOptions}
        >
          <p>{selectedName}</p>
        </button>
      </div>
      <div className={classes.Relative}>
        <div
          ref={optionsWrapperRef}
          className={classes.Options}
          style={dynamicStyles()}
        >
          {options.map((option, i) => (
            <button
              onClick={onClickFactory(option, toggleDropdownOptions)}
              key={`${option.name}${i}`}
              className={classes.Option}
            >
              <p>{option.name}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default memo(Dropdown);
